// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fbb5c96f","239":"b957b7f3","455":"dcc7e44f"}[chunkId] + ".chunk.js";
};